import { getColors } from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => ({
  "@global": {
    body: {
      backgroundColor: getColors(theme).backgroundColor
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
});

export default appStyle;
